import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './TopNav.css';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

export const TopNav: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  const baseNavItems: NavItem[] = [
    { path: '/', label: 'Home', icon: 'fas fa-home' },
    { path: '/tracking', label: 'Tracking', icon: 'fas fa-map-marker-alt' },
    { path: '/profile', label: 'Profile', icon: 'fas fa-user' },
  ];

  // Add technician link if user is a technician
  const isTechnician = user?.user_metadata?.role === 'technician';
  const navItems = isTechnician 
    ? [...baseNavItems, { path: '/technician', label: 'Technician', icon: 'fas fa-tools' }]
    : baseNavItems;

  return (
    <nav className="top-nav">
      <div className="nav-container">
        <div className="nav-logo">
          <img src="/OMWA-long-blk.png" alt="OnMyWayAuto" className="logo" />
        </div>
        <div className="nav-links">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-label"><i className={item.icon}></i>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};
